import { render, staticRenderFns } from "./forgot-password.component.vue?vue&type=template&id=dd5992e6"
import script from "./forgot-password.component.ts?vue&type=script&lang=ts&external"
export * from "./forgot-password.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd5992e6')) {
      api.createRecord('dd5992e6', component.options)
    } else {
      api.reload('dd5992e6', component.options)
    }
    module.hot.accept("./forgot-password.component.vue?vue&type=template&id=dd5992e6", function () {
      api.rerender('dd5992e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/forgot-password/forgot-password.component.vue"
export default component.exports